export const SOCKET_EVENTS = Object.freeze({
    UPDATE_ITEMS_LIST: 'updateItemsList',
    UPDATE_USER_EVENT: 'updateUserEvent',
    IS_STILL_EDITING: 'isStillEditing',
    FINISH_EDITING: 'finishEditing',
    VIDEO_PROCESSING_FINISH: 'videoProcessingFinish',
    VIDEO_PROCESSING_ERROR: 'videosProcessingError',
    VIDEO_PROCESSING_PROGRESS: 'videosProcessingProgress',
});
